import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';

function useDeleteQuiz() {
  const queryClient = useQueryClient();
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  function deleteQuiz(topicID, quizID) {
    return privateFetch.delete(`/v1/admin/topic/${topicID}/quiz/${quizID}`);
  }

  function manageQuiz(data = {}) {
    return deleteQuiz(data.topicID, data.quizID);
  }

  return useMutation(manageQuiz, {
    onSuccess() {},
    onSettled() {
      // this will invalidate all queries starting with 'quiz-lists'
      queryClient.invalidateQueries('quiz-lists');
    },
  });
}

export default useDeleteQuiz;
